// eslint-disable-next-line import/no-extraneous-dependencies
import { handleActions } from 'redux-actions';

import * as Actions from './actions';

const initialState = {
  isGetDeliveryRouteRequestReceiptRequest: false,
  isGetDeliveryRouteRequestReceiptSuccess: false,
  isGetDeliveryRouteRequestReceiptFailure: false,
  deliveryRouteRequestReceiptState: {},

  isUpdateStatusDeliveryRouteRequestReceiptRequest: false,
  isUpdateStatusDeliveryRouteRequestReceiptSuccess: false,
  isUpdateStatusDeliveryRouteRequestReceiptFailure: false,

  errorMessages: [],
};

const reducer = handleActions(
  {
    // #region: get list Delivery Route Request Receipt
    [Actions.getDeliveryRouteRequestReceiptRequest]: (state) => ({
      ...state,
      isGetDeliveryRouteRequestReceiptRequest: true,
      isGetDeliveryRouteRequestReceiptSuccess: false,
      isGetDeliveryRouteRequestReceiptFailure: false,
    }),
    [Actions.getDeliveryRouteRequestReceiptSuccess]: (state, { payload }) => ({
      ...state,
      isGetDeliveryRouteRequestReceiptRequest: false,
      isGetDeliveryRouteRequestReceiptSuccess: true,
      isGetDeliveryRouteRequestReceiptFailure: false,
      deliveryRouteRequestReceiptState: payload,
    }),
    [Actions.getDeliveryRouteRequestReceiptFailure]: (state, { payload }) => ({
      ...state,
      isGetDeliveryRouteRequestReceiptRequest: false,
      isGetDeliveryRouteRequestReceiptSuccess: false,
      isGetDeliveryRouteRequestReceiptFailure: true,
      errorMessages: payload,
    }),

    // #endregion
    // #region : update status delivery Route Request Receipt
    [Actions.updateStatusDeliveryRouteRequestReceiptRequest]: (state) => ({
      ...state,
      isUpdateStatusDeliveryRouteRequestReceiptRequest: true,
      isUpdateStatusDeliveryRouteRequestReceiptSuccess: false,
      isUpdateStatusDeliveryRouteRequestReceiptFailure: false,
    }),
    [Actions.updateStatusDeliveryRouteRequestReceiptSuccess]: (state) => ({
      ...state,
      isUpdateStatusDeliveryRouteRequestReceiptRequest: false,
      isUpdateStatusDeliveryRouteRequestReceiptSuccess: true,
      isUpdateStatusDeliveryRouteRequestReceiptFailure: false,
    }),
    [Actions.updateStatusDeliveryRouteRequestReceiptFailure]: (state, { payload }) => ({
      ...state,
      isUpdateStatusDeliveryRouteRequestReceiptRequest: false,
      isUpdateStatusDeliveryRouteRequestReceiptSuccess: false,
      isUpdateStatusDeliveryRouteRequestReceiptFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetUpdateStatusDeliveryRouteRequestReceiptState]: (state) => ({
      ...state,
      isUpdateStatusDeliveryRouteRequestReceiptRequest: false,
      isUpdateStatusDeliveryRouteRequestReceiptSuccess: false,
      isUpdateStatusDeliveryRouteRequestReceiptFailure: false,
    }),

    // #endregion
    // #region : Local
    [Actions.resetDeliveryRouteRequestReceiptState]: () => initialState,
    // #endregion
  },
  initialState,
);

export default reducer;
